import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-offwhite border-t border-navy/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-full bg-electric flex items-center justify-center">
                <span className="text-offwhite font-bold text-xl">KCC</span>
              </div>
              <div>
                <span className="text-navy font-bold text-lg">Koley Chemistry</span>
                <p className="text-navy/60 text-xs">Classes</p>
              </div>
            </div>
            <p className="text-navy/70 text-sm">
              Follow along our journey to enhance your chemistry for the competitive exams and make real-time progress with us.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-navy/60 hover:text-electric transition-colors duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-navy/60 hover:text-electric transition-colors duration-300">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-navy/60 hover:text-electric transition-colors duration-300">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://youtube.com/@koleychemistryclasseskcc9401" target="_blank" rel="noopener noreferrer" className="text-navy/60 hover:text-navy transition-colors duration-300">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-navy font-semibold mb-4">Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/mentors" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Mentors
                </Link>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-navy font-semibold mb-4">Community</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Students
                </a>
              </li>
              <li>
                <a href="#" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Parents
                </a>
              </li>
              <li>
                <a href="#" className="text-navy/70 hover:text-navy transition-colors duration-300 text-sm">
                  Alumni
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-navy font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-navy/70 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-electric" />
                <span>Centres: Salt Lake (Kolkata) and Bally (Howrah)</span>
              </li>
              <li className="flex items-center space-x-2 text-navy/70 text-sm">
                <Phone className="w-4 h-4 flex-shrink-0 text-electric" />
                <span>+91 7595888451</span>
              </li>
              <li className="flex items-center space-x-2 text-navy/70 text-sm">
                <Mail className="w-4 h-4 flex-shrink-0 text-electric" />
                <span>koleychemistryclasses@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-navy/10 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-navy/60 text-sm text-center sm:text-left break-words">
            Koley Chemistry Classes Inc. Copyrights Reserved 2024
          </p>
          <p className="text-navy/60 text-sm text-center sm:text-right break-words">
            Developed with ❤ by <a href="https://linkedin.com/in/jaiswal-krish" target="_blank" rel="noopener noreferrer" className="text-electric hover:text-electric-dark transition-colors duration-300">Krish</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
